const styles = theme => ({
  list: {
    padding: 0,
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/account/businesses/Businesses/List/styles.js